import { Fragment } from "react/jsx-runtime";

import { useCheckPart } from "#modules/similarPart/view/useCheckPart";
import { Icon } from "#shared/icons/Icon";
import { ActionIcon } from "#shared/view/components/ActionIcon";
import { Flex } from "#shared/view/components/Flex";
import { Text } from "#shared/view/components/Text";

export const TooltipContent = ({
  partId,
  errorMessage,
  setShouldDisplayTooltip,
}: {
  partId: string | undefined;
  setShouldDisplayTooltip: (shouldDisplayTooltip: boolean) => void;
  errorMessage: string;
}) => {
  const { checkPart } = useCheckPart();

  return (
    <Fragment>
      <Flex
        align={"center"}
        justify={"center"}
        gap="xxs"
        onClick={(e) => {
          e.stopPropagation();
          setShouldDisplayTooltip(false);
        }}
        data-testid="tooltip-content"
      >
        <Text>{errorMessage}</Text>

        {partId && (
          <ActionIcon
            size={"sm"}
            color="white"
            onClick={(e) => {
              e.stopPropagation();
              setShouldDisplayTooltip(false);
              checkPart({ id: partId });
            }}
          >
            <Icon name="refresh" />
          </ActionIcon>
        )}
      </Flex>
    </Fragment>
  );
};
